import * as React from 'react';
import { SVGProps } from 'react';

const SvgQuote = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#quote_svg__a)' fill='#000'>
      <path d='M16.5 16.5V21h-12V4H12V2.5H4.5A1.5 1.5 0 0 0 3 4v17a1.5 1.5 0 0 0 1.5 1.5h12A1.5 1.5 0 0 0 18 21v-4.5h-1.5Z' />
      <path d='M21.155 5.32 18.68 2.845a1.2 1.2 0 0 0-1.68 0l-10.5 10.5V17.5h4.148L21.148 7a1.2 1.2 0 0 0 0-1.68h.007ZM10.025 16H8v-2.025l7.08-7.088 2.033 2.033L10.024 16Zm8.145-8.138L16.137 5.83l1.703-1.703 2.032 2.033-1.702 1.702Z' />
    </g>
    <defs>
      <clipPath id='quote_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
);

export default SvgQuote;
